// src/filter/registry.ts
import type { FilterKey, Option } from "@/filter";

export type SourceKind =
  | { type: "static"; data: Option[] }
  | { type: "endpoint"; url: string; map?: (raw: any) => Option[] }
  | {
      type: "loader";
      load: (ctx?: { signal?: AbortSignal; q?: string }) => Promise<Option[]>;
    };

export type FilterRegistry = Record<FilterKey, SourceKind>;

export const defaultFilterRegistry: FilterRegistry = {
  filterName: {
    type: "static",
    data: [
      { label: "tes 1", value: "tes 1" },
      { label: "tes 2", value: "tes 2" },
    ],
  },
  kategoriPupuk: {
    type: "static",
    data: [
      { label: "Subsidi", value: "SUBSIDI" },
      { label: "Non Subsidi", value: "NONSUBSIDI" },
    ],
  },
  kategoriSurat: {
    type: "endpoint",
    url: "configuration/letter-type?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  // pengajuan
  status: {
    type: "static",
    data: [
      { label: "Diajukan", value: "DIAJUKAN" },
      { label: "Disetujui Admin Kecamatan", value: "SETUJUI_ADMIN_KECAMATAN" },
      { label: "Ditolak Admin Kecamatan", value: "TOLAK_ADMIN_KECAMATAN" },
      { label: "Disetujui Penyuluh", value: "SETUJUI_PENYULUH" },
      { label: "Ditolak Penyuluh", value: "TOLAK_PENYULUH" },
      { label: "Disetujui Dinas", value: "SETUJUI_DINAS" },
      { label: "Ditolak Dinas", value: "TOLAK_DINAS" },
      { label: "Terkirim", value: "TERKIRIM" },
      { label: "Selesai", value: "SELESAI" },
      { label: "Terlambat", value: "TERLAMBAT" },
    ],
  },
  poktan: {
    type: "endpoint",
    url: "master/poktan?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  jenisPupuk: {
    type: "endpoint",
    url: "master/tipe-pupuk?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  kategoriPengajuan: {
    type: "static",
    data: [
      { label: "Semua", value: "" },
      { label: "Subsidi", value: "SUBSIDI" },
      { label: "Non Subsidi", value: "NONSUBSIDI" },
    ],
  },
  jenisTanaman: {
    type: "endpoint",
    url: "master/plant?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
};
